module.exports = __webpack_public_path__ + "img/choose_list_1.ca21679a.png";